import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Container, Alert, Spinner } from 'react-bootstrap';
import { DataManager } from '../../core/data-manager';
import { Helmet } from 'react-helmet';
import moment from 'moment';


export default function Certificato() {

    const [errors, setErrors] = useState('');
    const { k } = useParams();
    const id = parseInt(k)

    const [data, setData] = useState(null);


    useEffect(() => {
        init()
    }, [id]);

    
    async function init() {
        var sorting = {
            'field': 'id',
            'order': 'desc'
        }
        var constraints = [
            {
                "fieldName": "idCourse",
                "type": "value",
                "value": id
            }
        ]
        var response = await DataManager.searchItems('gyv_course_user', 1, 1, sorting, '', [], constraints)
        if (response.success === 1 && response.body.length > 0) {
            setData(response.body[0])
        }
        else {
            setErrors('Non puoi visualizzare questo certificato.')
        }
    }



    if (data !== null) {
        return (
            <>
                <Helmet>
                    <title>Certificato - {data.idCourse.name}</title>
                </Helmet>
                
                <Container fluid='md'></Container>

                <Container fluid='md' className='mt-5 mb-5 text-center'>
                    <h3>Il tuo certificato!</h3>
                    <iframe
                        src={"https://api-elibrary.fedespedi.it/utils/temp/certificato.pdf"}
                        width="800"
                        height="1200"
                        allow="autoplay"
                        frameBorder="0"
                    ></iframe>
                </Container>
            </>
        )
    }
    else {
        return (
            <Container fluid='md' className='mt-5 mb-5'>
                {errors.length > 0 &&
                    <Alert variant='danger'>
                        {errors}
                    </Alert>
                }
                <div className='text-center p-5'>
                    <Spinner animation="border" variant="secondary" />
                    <p className='text-secondary'>Loading</p>
                </div>
            </Container>
        )
    }
};